// extracted by mini-css-extract-plugin
module.exports = {"icons":"styles_icons__1OeOr","children":"styles_children__1pHYB","actions":"styles_actions__2nEyo"};